/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-dialog-actions[_ngcontent-%COMP%]{justify-content:flex-end}mat-dialog-content[_ngcontent-%COMP%]{font-size:13px}mat-form-field[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
